export const environment = {
  name: 'test',
  production: true,
  apiClientId: '75dq6kcbnsmuk3qc17r02hnnjo',
  userPoolId: 'eu-west-1_k3USnpTGz',
  graphqlEndpoint:
    'https://jn3jyukdcjcfplv2axxmi26rnu.appsync-api.eu-west-1.amazonaws.com/graphql',
  eventsEndpoint: '', // populate from CDK output BFF:EventsAPIHTTPEndpoint
  graphqlApiKey: 'da2-7zfnzfe5vzadddyzrgsjcxay7e',
}
